<ng-template #htmlContent>
  <ng-content></ng-content>
</ng-template>

@if (routerLink()) {
  <a #el [routerLink]="routerLink()" [queryParams]="queryParams()" [class]="twClasses()" (click)="onClick()"
    >{{ content() }}<ng-container *ngTemplateOutlet="htmlContent"
  /></a>
} @else {
  <button #el [disabled]="disabled()" [class]="twClasses()" (click)="onClick()">
    {{ content() }}<ng-container *ngTemplateOutlet="htmlContent" />
  </button>
}
